// Centralised route constants for the investor bank-accounts directory
// module. Backend route renames are a one-file change.
//
// NOTE: this endpoint lives under /api/admin/investors/bank-accounts
// in admin-service — investor bank accounts, NOT treasury accounts.

const BANK_ACCOUNTS = '/api/admin/investors/bank-accounts'

export const BANK_ACCOUNTS_DIRECTORY_ENDPOINT_PATHS = {
  LIST: BANK_ACCOUNTS,
  DETAIL: (id: string) => `${BANK_ACCOUNTS}/${id}`,
} as const
